// extracted by mini-css-extract-plugin
export default {"select":"EditSbatGroupInstructorsForm_select__2xXBm"};